import { computed, Injectable, ViewContainerRef } from '@angular/core';
import { ComponentType } from '@angular/cdk/overlay';
import { sideBarTokenizer } from '../store';

@Injectable()
export class HandleSideBarService {
  private readonly _handleSideBarStore = sideBarTokenizer();

  $currentComponentRef = computed(() =>
    this._handleSideBarStore.$currentComponentRef(),
  );

  $toggleSideBar = computed(() => this._handleSideBarStore.$toggleSideBar());

  $currentViewContainerRef = computed(() =>
    this._handleSideBarStore.$currentViewContainerRef(),
  );

  setVCR(vcr: ViewContainerRef): void {
    this._handleSideBarStore.setCurrentViewContainerRef(vcr);
  }

  setSideBarComponent(component: ComponentType<unknown>): void {
    this._handleSideBarStore.setCurrentViewContainerComponent(component);
  }

  /**
   * @NOTE:- The following method will only clear currentComponentRef.
   */
  clearCurrentComponentRef(): void {
    this._handleSideBarStore.clearCurrentComponentRef();
  }

  /**
   * @NOTE: - The following method will clear both currentViewContainerRef and currentComponentRef
   */
  clearVCR(): void {
    this._handleSideBarStore.clearCurrentViewContainerRef();
  }

  setToggleSideBarOpen(isOpen: boolean): void {
    this._handleSideBarStore.toggleSideBarOpen(isOpen);
  }
}
